export const airports = {
  'CAI': {'code': 'CAI', 'name': 'Cairo', 'city_code': 'CAI', 'city': 'Cairo', 'country': 'Egypt'},
  'YUL': {
    'code': 'YUL',
    'name': 'Montreal-Pierre Elliott Trudeau International Airport',
    'city_code': 'YMQ',
    'city': 'Montreal',
    'country': 'Canada'
  },
  'YYZ': {
    'code': 'YYZ',
    'name': 'Pearson International Airport',
    'city_code': 'YTO',
    'city': 'Toronto',
    'country': 'Canada'
  },
  'TLV': {'code': 'TLV', 'name': 'Tel Aviv-Yafo', 'city_code': 'TLV', 'city': 'Tel Aviv-Yafo', 'country': 'Israel'},
  'MSP': {'code': 'MSP', 'name': 'Minneapolis', 'city_code': 'MSP', 'city': 'Minneapolis', 'country': 'United States'}
}
